import styled from 'styled-components';

import { PageContentContainer } from '../../../../styles/containers.sc';

export const PageContentContainerS = styled(PageContentContainer)`
  padding: 30px 0 30px;
`;

export const AddQuestionContainer = styled.div`
  margin-top: 60px;
`;
